import React, { useState, useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QRCodeScanner = ({ onScanSuccess, loading }) => {
  const [scanning, setScanning] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let scanner = null;

    if (scanning) {
      scanner = new Html5QrcodeScanner(
        'qr-reader',
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
          aspectRatio: 1.0
        },
        false
      );

      scanner?.render(
        (decodedText) => {
          setScanResult(decodedText);
          setScanning(false);
          scanner?.clear();
          onScanSuccess?.('qr_code');
        },
        (errorMessage) => {
          // Ignore scan errors during scanning
        }
      );
    }

    return () => {
      if (scanner) {
        scanner?.clear()?.catch(() => {});
      }
    };
  }, [scanning]);

  const startScanning = () => {
    setError(null);
    setScanResult(null);
    setScanning(true);
  };

  const stopScanning = () => {
    setScanning(false);
  };

  return (
    <div className="card">
      <div className="text-center">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-foreground mb-2">Scan QR Code</h2>
          <p className="text-muted-foreground">Scan member QR codes for quick check-in</p>
        </div>

        {!scanning && !scanResult && (
          <div className="space-y-6">
            <div className="flex justify-center">
              <div className="w-64 h-64 bg-muted/30 rounded-2xl flex items-center justify-center">
                <Icon name="ScanLine" size={80} className="text-muted-foreground" />
              </div>
            </div>

            <Button onClick={startScanning} size="lg" className="w-full max-w-md mx-auto">
              <Icon name="Camera" size={20} />
              <span>Start Scanning</span>
            </Button>

            <div className="p-4 bg-warning/5 rounded-lg border border-warning/20">
              <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
                <Icon name="AlertCircle" size={16} className="text-warning" />
                Camera permission required for scanning
              </p>
            </div>
          </div>
        )}

        {scanning && (
          <div className="space-y-6">
            <div id="qr-reader" className="mx-auto max-w-md"></div>

            <Button onClick={stopScanning} variant="outline" className="w-full max-w-md mx-auto">
              <Icon name="X" size={20} />
              <span>Cancel Scanning</span>
            </Button>
          </div>
        )}

        {scanResult && (
          <div className="space-y-6">
            <div className="flex justify-center">
              <div className="w-64 h-64 bg-success/10 rounded-2xl flex items-center justify-center">
                <Icon name="CheckCircle" size={80} className="text-success" />
              </div>
            </div>

            <div className="p-4 bg-success/10 rounded-lg border border-success/20">
              <h3 className="font-semibold text-success mb-2">Scan Successful!</h3>
              <p className="text-sm text-muted-foreground">Member checked in successfully</p>
            </div>

            <Button onClick={startScanning} size="lg" className="w-full max-w-md mx-auto">
              <Icon name="ScanLine" size={20} />
              <span>Scan Another</span>
            </Button>
          </div>
        )}

        {error && (
          <div className="mt-4 p-4 bg-error/10 rounded-lg border border-error/20">
            <p className="text-sm text-error">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCodeScanner;